export default "__VITE_ASSET__QLxX5q7g__"